import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LinearProgress from '@mui/material/LinearProgress';

import OwnerProfile from './OwnerProfile';
import SitterProfile from './SitterProfile';
import { selectProfile } from './selector';
import { fetchProfile } from './action';

const Profile = () => {
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  if (!profile) return <LinearProgress />;

  const isPetOwner =
    localStorage.getItem('isPetOwner') ?
      JSON.parse(localStorage.getItem('isPetOwner')) :
      true;

  return isPetOwner ? (
    <OwnerProfile profile={profile} />
  ) : (
    <SitterProfile profile={profile} />
  );
};

export default Profile;
